import { Component, OnInit, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
    selector: 'access-denied',
    templateUrl: 'access.denied.component.html',
    styleUrls: ['access.denied.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccessDeniedComponent implements OnInit {
    @HostBinding('class.modern-form') modern = true;

    constructor(private store: Store<any>) { }

    ngOnInit() { }

    onLogin() {

        const action = {
            type: '[Application] Logout',
            payload: {
                force: true
            }
        };

        this.store.dispatch(action);
    }
}
